import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { GraduationCap } from "lucide-react";

const TERMS = [
  ["What is Polymarket?", "A website where people bet on real-world questions (\"Will BTC be above $100k on Friday?\"). Each answer — like Yes or No — has a price between 0¢ and $1."],
  ["What does an outcome price mean?", "The price is the crowd's guess of the chance it happens. 65¢ on \"Yes\" ≈ the crowd thinks there's a 65% chance. If it happens, each share pays $1; if not, $0."],
  ["What are the 1 / 5 / 15 min changes?", "How far Bitcoin's price moved compared to 1, 5 or 15 minutes ago. Short windows react fast but jump around; the 15-min window is steadier."],
  ["What do UP / DOWN / MIXED mean?", "UP = all three windows rose. DOWN = all three fell. MIXED = they disagree, so there's no clear trend."],
  ["What is Volume?", "How much money was traded on a market in the last 24 hours. Higher volume usually means more people are paying attention and prices are more reliable."],
  ["What is the Readings Log?", "Every 60 seconds the dashboard saves a snapshot (price, changes, momentum) so you can look back and see how things moved."],
];

export const Glossary = () => (
  <section className="card px-5 sm:px-6 py-2" data-testid="glossary">
    <Accordion type="single" collapsible>
      <AccordionItem value="guide" className="border-0">
        <AccordionTrigger className="hover:no-underline" data-testid="glossary-toggle">
          <span className="flex items-center gap-2 font-head font-bold text-base">
            <GraduationCap className="w-5 h-5 text-[#22D3EE]" /> New here? Beginner's guide
          </span>
        </AccordionTrigger>
        <AccordionContent>
          <div className="grid sm:grid-cols-2 gap-4 pt-1">
            {TERMS.map(([q, a]) => (
              <div key={q} className="border-l-2 border-[#22D3EE] pl-3">
                <div className="font-semibold text-sm text-slate-100">{q}</div>
                <p className="text-sm text-slate-400 leading-relaxed mt-1">{a}</p>
              </div>
            ))}
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  </section>
);
